import React from "react";
import withStyles from "react-jss";
import { Link } from "react-router-dom";
import LazyImage from "ComponentsUI/Image";

const styles = (theme) => ({
	logoWrapper: {
		width: "100%",
		height: "100%",
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
	},
	img: {
		maxHeight: "50px",
		maxWidth: "100%",
		objectFit: "scale-down",
	},
	[`@media (max-width: ${theme.media.sm})`]: {
		img: {
			maxHeight: "30px",
			width: "auto",
		},
	},
});

const ProviderLogo = ({ classes, webpTransformer, path, name, link }) => {
	return (
		<div className={classes.logoWrapper}>
			<Link to={link} aria-label={`Лого компании ${name}`}>
				<LazyImage
					src={!!webpTransformer ? webpTransformer(path) : path}
					className={classes.img}
					alt={name}
				/>
			</Link>
		</div>
	);
};

export default withStyles(styles)(ProviderLogo);
